export const LISTING_RESTRICTION_URL = '/listing-restriction'
export const SELLING_RESTRICTION_URL = '/selling-restriction'
